import { ButtonHTMLAttributes, forwardRef, ReactNode } from "react";
import s from "./IconButton.module.scss";

export type IconButtonProps = { label: string; icon: ReactNode; size?: "md" | "lg" } & ButtonHTMLAttributes<HTMLButtonElement>;

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ label, icon, size = "md", type = "button", className, ...rest }, ref) => (
    <button ref={ref} type={type} aria-label={label} title={label} className={[s.ib, s[size], className ?? ""].join(" ").trim()} {...rest}>
      <span aria-hidden className={s.glyph}>{icon}</span>
    </button>
  )
);
IconButton.displayName = "IconButton";
